// sep 2026 · Preparación para la app de iOS (Capacitor). No se usa
// todavía en ningún flujo existente — es la capa "puente" para que,
// cuando la app corra dentro del wrapper nativo de iOS (o Android vía
// Capacitor en el futuro), las nuevas funciones puedan pedir cámara/
// compartir/ubicación nativos en vez de las APIs del navegador, sin
// tocar los ~18 sitios que ya usan `navigator.share` hoy (funcionan
// igual dentro de la WebView, no hacía falta arriesgar ese código sin
// poder probarlo en un dispositivo real todavía).
import { Capacitor } from '@capacitor/core';

export const isNativeApp = () => Capacitor.isNativePlatform();

export const nativePlatform = () => Capacitor.getPlatform(); // 'ios' | 'android' | 'web'

/** Compartir nativo (hoja de compartir de iOS/Android). Devuelve false si no aplica —
 * el caller debe seguir usando su fallback actual (`navigator.share` / copiar enlace). */
export async function shareNative({ title, text, url, dialogTitle }) {
  if (!isNativeApp()) return false;
  try {
    const { Share } = await import('@capacitor/share');
    await Share.share({ title, text, url, dialogTitle: dialogTitle || title });
    return true;
  } catch (_e) {
    return false; // usuario canceló o el plugin no está disponible
  }
}

/** Foto con la cámara nativa. Devuelve un dataUrl (string) o null si no aplica/cancela. */
export async function takePhotoNative() {
  if (!isNativeApp()) return null;
  try {
    const { Camera, CameraResultType, CameraSource } = await import('@capacitor/camera');
    const photo = await Camera.getPhoto({
      resultType: CameraResultType.DataUrl,
      source: CameraSource.Prompt, // deja elegir cámara o galería, como el <input type=file> actual
      quality: 85,
    });
    return photo?.dataUrl || null;
  } catch (_e) {
    return null;
  }
}

/** Ubicación nativa (más precisa que la del navegador en iOS). Devuelve {latitude,longitude} o null. */
export async function getCurrentPositionNative() {
  if (!isNativeApp()) return null;
  try {
    const { Geolocation } = await import('@capacitor/geolocation');
    const pos = await Geolocation.getCurrentPosition();
    return { latitude: pos.coords.latitude, longitude: pos.coords.longitude };
  } catch (_e) {
    return null;
  }
}

// Fallbacks: our UA tag (capacitor.config appendUserAgent) or the iOS native bridge handler.
const IOS_SHELL = typeof window !== 'undefined' && (
  /ToviasApp-iOS/.test(navigator.userAgent || '') || !!window.webkit?.messageHandlers?.bridge
);
export const isNativeIOS = () => (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') || IOS_SHELL;

// Dentro de la app nativa, navigator.share abre la hoja de compartir de iOS (cubre todos los botones existentes).
export function installNativeShare() {
  if (!isNativeApp()) return;
  Object.defineProperty(navigator, 'share', {
    configurable: true,
    value: async ({ title, text, url } = {}) => {
      const { Share } = await import('@capacitor/share');
      await Share.share({ title, text, url, dialogTitle: title });
    },
  });
  Object.defineProperty(navigator, 'canShare', { configurable: true, value: () => true });
}
